"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargePayCheckDto = void 0;
const class_validator_1 = require("class-validator");
const transform_bool_1 = require("../../../../shared/pipes/transform-bool");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
/**
 * Запрос на проверку возможности оплаты начислений,
 * а также подсчёт суммы к оплате
 */
let BillingApiChargePayCheckDto = class BillingApiChargePayCheckDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Подключить в выдачу информацию о начислениях",
  type: Boolean,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), (0, transform_bool_1.TransformBool)(), __metadata("design:type", Object)], BillingApiChargePayCheckDto.prototype, "joinCharge", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Подключить в выдачу информацию о сделке",
  type: Boolean,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), (0, transform_bool_1.TransformBool)(), __metadata("design:type", Object)], BillingApiChargePayCheckDto.prototype, "joinOrder", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Начисления для которых проверяется возможность оплаты",
  type: String,
  isArray: true,
  items: {
    format: "uuid"
  }
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4, {
  each: true
}), __metadata("design:type", Array)], BillingApiChargePayCheckDto.prototype, "chargeId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Id платёжного счёта (не бязательно). Если нет, цена отображается в валюте по умолчанию для
      провайдера Stripe - USD.`,
  type: String,
  format: "uuid",
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiChargePayCheckDto.prototype, "accountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Целевая валюта для показа примерной стоимости в ней",
  example: "EUR",
  required: false,
  nullable: true
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiChargePayCheckDto.prototype, "currencyCode", void 0);
BillingApiChargePayCheckDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiChargePayCheckDto);
exports.BillingApiChargePayCheckDto = BillingApiChargePayCheckDto;
